// Aca declaro constantes con las url que voy a usar

export const BASE_URL = "https://backend-countries-pi.herokuapp.com";
export const ALL_COUNTRIES_URL = BASE_URL +"/countries/all";
export const ACTIVITIES_URL = BASE_URL +"/activities/";
export const COUNTRIES_URL= BASE_URL + "/countries";
export const COUNTRIES_NAME = COUNTRIES_URL + "?name=";
export const COUNTRIES_ID = COUNTRIES_URL + "/";